import { AddressNameField } from 'forms/sections/relationships/people/types';

export const contactFrequencyOptions = ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Annually', 'Other'];

export const foreignBusinessVenturesAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name'
  }
];

export const foreignBusinessSponsorshipAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name'
  }
];

export const foreignBusinessAddressNameFields: AddressNameField[] = [
  {
    addressFields: [],
    nameField: 'Item.Name'
  }
];

export const alcoholSupplementalCounselingAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProviderName.value',
  }
];

export const alcoholMandatoryCounselingAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProviderName.value',
  }
];

export const alcoholReceivedCounselingAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProviderName.value',
  }
];

export const alcoholVoluntaryCounselingAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProviderName.value',
  }
];

export const financialRecordAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TrusteeAddress'],
    nameField: 'Item.Trustee.value',
  }
];

export const residenceAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.ReferenceAddress', 'Item.ReferenceAlternateAddress.Address'],
    nameField: 'Item.ReferenceName',
  }
];

export const employmentAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Supervisor.Address', 'Item.Supervisor.AlternateAddress.Address'],
    nameField: 'Item.Supervisor.SupervisorName.value',
  },
  {
    addressFields: ['Item.ReferenceAddress', 'Item.ReferenceAlternateAddress.Address'],
    nameField: 'Item.ReferenceName',
  }
];

export const relativesAddressNameFields: AddressNameField[] = [{
  addressFields: ['Item.Address', 'Item.AlternateAddress.Address'],
  nameField: 'Item.Name',
}];

export const divorceAddressNameFields: AddressNameField[] = [{
  addressFields: [''],
  nameField: 'Item.Name',
}];

export const civilUnionAddressNameFields: AddressNameField[] = [{
  addressFields: ['Address'],
  nameField: 'Name',
}];

export const drugsSupplementalTreatmentAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProvider',
  }
];

export const drugsMandatoryTreatmentAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProvider',
  }
];

export const drugsVoluntaryTreatmentAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.TreatmentProviderAddress'],
    nameField: 'Item.TreatmentProvider',
  }
];

export const foreignServiceAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name',
  }
];

export const foreignContactsAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name',
  }
];

export const coOwnersAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name',
  }
];

export const foreignSupportAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name',
  }
];

export const indirectInterestAddressNameFields: AddressNameField[] = [
  {
    addressFields: [''],
    nameField: 'Name',
  }
];

export const educationAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.ReferenceAddress'],
    nameField: 'Item.ReferenceName',
  }
];

export const diagnosesAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Treatment.Address'],
    nameField: 'Item.Treatment.Name.value',
  }
];

export const psychologicalTreatmentAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name.value',
  }
];

export const peopleAddressNameFields: AddressNameField[] = [
  {
    addressFields: ['Item.Address'],
    nameField: 'Item.Name',
  }
];

export const relationshipOptionsPvq = ['Family', 'Friend', 'Schoolmate', 'Neighbor', 'Work Associate', 'Landlord', 'Other'];
